import app from "firebase/app";
import FirebaseContext from "./firebaseContext";
import React, { useState, useEffect } from "react";
import "firebase/auth";
import "firebase/firebase-firestore";

var config = {
  apiKey: "AIzaSyDrJZoV0YLXv2Ts7J5UwInK88Lra2-x0GY",
  authDomain: "bio-bic.firebaseapp.com",
  databaseURL: "https://bio-bic.firebaseio.com",
  projectId: "bio-bic",
  storageBucket: "bio-bic.appspot.com",
  messagingSenderId: "1000522445342",
  appId: "1:1000522445342:web:3e8a5dbe2b57f3ec0e740f",
  measurementId: "G-C4YZRN47TR"
};
const FirebaseState = props => {
  if (!app.apps.length) {
    try {
      app.initializeApp(config);
    } catch (err) {
      console.error("Errorrrr", err.stack);
    }
  }

  const auth = app.auth();
  const db = app.firestore();

  const [authenticated, setAuthenticated] = useState(false);

  const login = async (email, password) => {
    const res = await auth.signInWithEmailAndPassword(email, password);
  };

  return (
    <div>
      <FirebaseContext.Provider value={{ auth, db, login }}>
        {props.children}
      </FirebaseContext.Provider>
    </div>
  );
};

export default FirebaseState;
